import axios from 'axios';

import { webpack } from '@dr.pogodin/react-utils';

import type {
  CreateSessionBodyT,
  CreateSessionResT,
  FinishSessionBodyT,
  FinishSessionResT,
  ListSessionsQueryT,
  ListSessionsResT,
  UpdateSessionBodyT,
  UpdateSessionResT,
} from 'server/controllers/session';

import type * as SST from 'server/services/session';

import {
  type GetSessionsArgT,
  P_API_SESSIONS,
  type SessionT,
  getConfig,
} from 'utils';

const ss = webpack.requireWeak<typeof SST>('server/services/session', import.meta.dirname);

const BASE = '/__api__/session';

// TODO: Perhaps, it is more convenient to return entire created session object?
export async function createSession(session: SessionT): Promise<string> {
  const config = getConfig(true);
  const res = await axios.post<CreateSessionResT>(BASE, {
    _csrf: config.CSRF,
    session,
  } satisfies CreateSessionBodyT);

  return res.data;
}

export async function finishSession(session: SessionT): Promise<SessionT> {
  const config = await getConfig();

  if (!session.id) throw Error('Missing session ID');
  const res = await axios.post<FinishSessionResT>(
    `${BASE}/${session.id}/finish`,
    { _csrf: config.CSRF } satisfies FinishSessionBodyT,
  );
  return res.data;
}

export async function getSessions(
  options: GetSessionsArgT,
): Promise<SessionT[]> {
  if (ss) return ss.getSessions(options);

  const { data } = await axios<ListSessionsResT>(BASE, {
    params: options satisfies ListSessionsQueryT,
  });

  return data;
}

type UpdateSessionPayloadT = {
  /** ID of the UserScore record. */
  immediateImpactScore: string;
};

export async function updateSession(
  id: string,
  session: UpdateSessionPayloadT,
): Promise<SessionT> {
  if (ss) throw Error('Client-side only');

  const config = await getConfig();
  const { data } = await axios.patch<UpdateSessionResT>(
    `${P_API_SESSIONS}/${id}`,
    {
      _csrf: config.CSRF,
      session,
    } satisfies UpdateSessionBodyT,
  );

  return data;
}
